module.exports = __webpack_public_path__ + "static/media/close.c5e6b01c.svg";